// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__TBGDH","rightAdornment":"Header_rightAdornment__1WjCH"};